import TextField from './TextField';
import TextFieldFetch from './TextFieldFetch';
import DateField from './DateField';
import Checkbox from './Checkbox';
import AddProperty from './AddProperty';
import CheckboxGroup from './CheckboxGroup';
import UploadDocument from './UploadDocument';
import TextReview from './TextReview';
import CheckboxGroupReview from './CheckboxGroupReview';
import DocumentsReview from './DocumentsReview';

export default {
  TextField,
  TextFieldFetch,
  DateField,
  Checkbox,
  AddProperty,
  CheckboxGroup,
  UploadDocument,
  TextReview,
  CheckboxGroupReview,
  DocumentsReview,
};
